import styled from 'styled-components';
import colors from '../../../assets/styles/colors';

export const AditinalDataHeaderDescription = styled.p`
  font-size: 14px;
  line-height: 23px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  margin: 0;
`;
